import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyTelegram = lazy(() => import('./Telegram'));

export const Telegram: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyTelegram {...props} />
	</Suspense>
);
